import { addDimensions } from '@eventbrite/site-analytics';
import { $FixMe } from '@eventbrite/ts-utils';
import {
    getSplitNames,
    getTreatments,
    initSplitSdk,
} from '@splitsoftware/splitio-redux';
import { Dispatch } from 'redux';
import { getActiveFFsFromCore } from '../selectors/app';
import {
    getEventCountryCode,
    getEventOrganizationId,
} from '../selectors/event';
import { isSplitTreatmentEnabled } from '../selectors/splitio';
import { CheckoutState } from '../state';
import { getSplitioClient } from '../utils/splitio';

export const initializeSplitioSdk =
    () =>
    async (
        dispatch: Dispatch<CheckoutState>,
        getState: () => CheckoutState,
    ) => {
        const {
            app: {
                isProd,
                splitIOProdKey,
                event: { id: eventId },
            },
        } = getState();

        const countryCode = getEventCountryCode(getState());
        const organizationId = getEventOrganizationId(getState());

        // Don't initialize SDK if there is no prod key (eg. unit tests)
        if (!splitIOProdKey) return;

        await dispatch(
            initSplitSdk({
                config: getSplitioClient(
                    eventId,
                    isProd ? splitIOProdKey : null,
                ),
            }) as $FixMe,
        );

        const splitNames = getSplitNames();

        // Apply attributes to evaluate splits
        dispatch(
            getTreatments({
                splitNames: splitNames,
                attributes: { eventId, countryCode, organizationId },
            }) as any,
        );

        // Send split values to analytics
        const state = getState();
        const activeFFsFromCore = getActiveFFsFromCore(state);
        const activeSplits = splitNames.flatMap((name) => {
            const value = isSplitTreatmentEnabled(state, name);
            return value ? [name] : [];
        });
        addDimensions({
            experimentId: [...activeSplits, ...activeFFsFromCore]
                .sort()
                .join(','),
        });

        return Promise.resolve();
    };
